import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class BackgroundAnimate {
    constructor(el) {
        this.el = el;
        this.setVars();
        this.init();
    }

    setVars() {
        this.animate = this.el.querySelectorAll('[data-animate]');
    }
    init() {
        if(this.animate.length > 0) {
            this.handleAnimation(this.animate.length);
        }
    }

    handleAnimation(length) {
        let duration = 1;
        let stagger = 0.2;

        if(length > 10) {
            stagger = 0.05;
        } else if (length > 5) {
            stagger = 0.08;
        }

        gsap.set(this.animate, {autoAlpha: 0});
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.el,
                start: "top center"
            }
        })

        tl.to(this.animate, {
            autoAlpha: 1,
            stagger: stagger,
            ease: "power1.inOut",
            duration: duration
        })
    }




}
